<!-- Copyright Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information. -->

<div class="fl-component">
  @if (settings.showLabel && settings.label) {
    <div class="lib-datetime-label">{{ settings.label }}</div>
  }
  <div [formGroup]="formGroup" class="fl-datetime-inputs" [style]="this.getCombinedStyles(this.settings)">
    <input type="text" #dateTimeInput [formControlName]="dateTimeControlName ?? ''" hidden />
    <br />
    @if (settings.capturedInBackend) {
      <span>
        {{
          settings.showTimeOnly
            ? strings?.timeCapturedInBackend
            : settings.showTime
              ? strings?.dateTimeCapturedInBackend
              : strings?.dateCapturedInBackend
        }}
      </span>
    } @else {
      @if (settings.showTimeOnly !== true) {
        <div class="fl-date-container" [ngClass]="settings.combinedDateTime ? 'combined-datetime' : ''">
          <div class="lib-datetime-picker" #dateDiv>
            @if (settings.useCurrentDate && config.isDisplayOnly) {
              <input
                class="fl-datetime-input-date"
                type="text"
                id="{{ settings.fieldId }}"
                value="{{ strings?.currentDate }}"
                disabled
              />
            }
            <mat-form-field class="lf-field lf-date-field lf-datepicker-input-box" appearance="outline">
              <input
                matInput
                class="fl-datetime-input-date"
                id="{{ settings.fieldId }}"
                type="text"
                data-input
                [readonly]="state.readonly || state.disabled"
                (blur)="onBlurWithKey('date')"
                [hidden]="settings.useCurrentDate && config.isDisplayOnly"
                [placeholder]="settings.datePlaceholder ?? ''"
                [formControlName]="dateControlName ?? ''"
                [ngClass]="{
                  'ng-wrapper-invalid': dateTimeControl?.invalid,
                  'ng-wrapper-touched': dateTimeControl?.touched,
                }"
              />
              @if (!state.readonly) {
                <a
                  class="datetime-icon"
                  title="{{ strings?.selectDate }}"
                  [ngClass]="{ isDisabled: config.isDisplayOnly || state.disabled, hidden: showLoadingSpinner }"
                  [attr.disabled]="config.isDisplayOnly"
                  data-toggle
                  (click)="onIconClick('date')"
                >
                  <div style="box-sizing: border-box">
                    <svg class="lf-icon-16">
                      <symbol xmlns="http://www.w3.org/2000/svg" id="date" viewBox="0 0 24 24">
                        <path
                          d="M19,3h-1V1h-2v2H8V1H6v2H5C3.9,3,3,3.9,3,5l0,14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V8h14V19z"
                        ></path>
                        <rect x="7" y="10" width="5" height="5"></rect>
                      </symbol>
                      <use xlink:href="#date"></use>
                    </svg>
                  </div>
                </a>
              }
            </mat-form-field>
            @if (showLoadingSpinner) {
              <div>
                <ng-content select="[loading-spinner]"></ng-content>
              </div>
            }
          </div>
          @if (dateControl?.invalid && dateControl?.touched && errorMessages) {
            <div class="error-message">
              {{ errorMessages.date }}
            </div>
          }
        </div>
      }
      <ng-content select="[between-pickers]"></ng-content>
      @if (settings.showTime && !settings.combinedDateTime) {
        <div class="fl-time-container">
          <div class="lib-datetime-picker" #timedateDiv>
            @if (settings.useCurrentDate && config.isDisplayOnly) {
              <input class="fl-datetime-input-time" type="text" value="{{ strings?.currentTime }}" disabled />
            }
            <mat-form-field class="lf-field lf-date-field lf-datepicker-input-box" appearance="outline">
              <input
                matInput
                class="fl-datetime-input-time"
                id="DateTime{{ settings.fieldId }}"
                type="text"
                data-input
                [hidden]="settings.useCurrentDate && config.isDisplayOnly"
                [readonly]="state.readonly || state.disabled"
                (blur)="onBlurWithKey('time')"
                [placeholder]="settings.timePlaceholder ?? ''"
                [formControlName]="timeControlName ?? ''"
                [ngClass]="{
                  'ng-wrapper-invalid': dateTimeControl?.invalid,
                  'ng-wrapper-touched': dateTimeControl?.touched,
                }"
              />
              @if (!state.readonly) {
                <a
                  class="datetime-icon"
                  title="{{ strings?.selectTime }}"
                  [ngClass]="{ isDisabled: config.isDisplayOnly || state.disabled, hidden: showLoadingSpinner }"
                  data-toggle
                  (click)="onIconClick('time')"
                >
                  <div style="box-sizing: border-box">
                    <svg class="lf-icon-16">
                      <symbol xmlns="http://www.w3.org/2000/svg" id="clock" viewBox="0 0 24 24">
                        <path
                          d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10c5.5,0,10-4.5,10-10S17.5,2,12,2z M12,20c-4.4,0-8-3.6-8-8s3.6-8,8-8c4.4,0,8,3.6,8,8S16.4,20,12,20z"
                        ></path>
                        <polygon points="12.5,7 11,7 11,13 16.2,16.2 17,14.9 12.5,12.3 "></polygon>
                      </symbol>
                      <use xlink:href="#clock"></use>
                    </svg>
                  </div>
                </a>
              }
            </mat-form-field>
            @if (showLoadingSpinner) {
              <div>
                <ng-content select="[loading-spinner]"></ng-content>
              </div>
            }
          </div>
          @if (timeControl?.invalid && timeControl?.touched) {
            <div class="error-message">{{ errorMessages?.time }}</div>
          }
        </div>
      }
      <ng-content></ng-content>
    }
  </div>
  @if (dateTimeControl?.invalid && dateTimeControl?.touched && errorMessages?.dateTime) {
    <div class="error-message">
      {{ errorMessages?.dateTime }}
    </div>
  }
</div>
